import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBank = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-landmark-icon lucide-landmark",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M10 18v-7" }),
		/* @__PURE__ */ _jsx("path", { d: "M11.12 2.198a2 2 0 0 1 1.76.006l7.866 3.847c.476.233.31.949-.22.949H3.474c-.53 0-.695-.716-.22-.949z" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 18v-7" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 18v-7" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 22h18" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 18v-7" })
	]
});
export default SvgBank;
